"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const functions_1 = require("@/common/functions");
function default_1(error) {
    var _a, _b;
    const errorCode = (_b = (_a = error.response.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.alert_type;
    switch (errorCode) {
        case 40300: // ! 비로그인
            alert(i18next_1.default.t('로그인이 필요해요!'));
            window.location.replace('/login');
            break;
        default: // ! 소유자 아닌 경우(40301)
            (0, functions_1.replaceToMain)();
    }
}
exports.default = default_1;
